// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1jLdj","vLegacy":"SelectSecondary_vLegacy__3603m","error":"SelectSecondary_error__1T9hE","disabled":"SelectSecondary_disabled__170q4"};